import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { http } from "../../shared/api/http.js";

export type LeadStatus = "new" | "contacted" | "quoted" | "won" | "lost";

export interface Lead {
  id: string;
  contactName: string;
  email: string;
  phone: string | null;
  eventDate: string | null;
  eventType: string | null;
  guestEstimate: number | null;
  message: string | null;
  status: LeadStatus;
  adminNotes: string | null;
  convertedUserId: string | null;
  createdAt: string;
}

const KEY = ["admin", "leads"] as const;

export const useLeads = () =>
  useQuery({ queryKey: KEY, queryFn: () => http.get<{ items: Lead[] }>("/admin/quote-requests") });

export function useUpdateLead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: { status?: LeadStatus; adminNotes?: string } }) =>
      http.patch(`/admin/quote-requests/${id}`, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useConvertLead(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { name: string; email: string; mode: "password" | "invite"; password?: string }) =>
      http.post<{ userId: string; inviteUrl: string | null }>(
        `/admin/quote-requests/${id}/convert`,
        v,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
      qc.invalidateQueries({ queryKey: ["admin", "clients"] });
    },
  });
}
